import { parseCookies } from "nookies";

export async function FetchEvents(type, stat, page) {
  const serverURL = process.env.NEXT_PUBLIC_REACT_APP_SERVER;
  let url = `${serverURL}/events`;
  const cookies = parseCookies();
  const token = cookies.token;

  const params = new URLSearchParams();
  if (type) params.append("type", type);
  if (stat !== undefined && stat !== null) params.append("status", stat);
  if (page !== undefined && page !== null) params.append("page", page);

  if ([...params].length > 0) {
    url += `?${params.toString()}`;
  }

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch events");
  }

  return res.json();
}
